import Mapbox from "./Mapbox";
//import Analytics from "./Analytics";
//window.segment = new Analytics();
window.Mapbox = new Mapbox(import.meta.env.VITE_RADAR_PUBLISHABLE_KEY);

window.addEventListener("segment.track", (e) => {
    // determinar si existe variable sessionStorage
    if (typeof sessionStorage !== 'undefined') {
        // determinar si existe la variable envia_eventos_amplitude
        if (sessionStorage.getItem('envia_eventos_amplitude') === null) {
            sessionStorage.setItem('envia_eventos_amplitude', Math.random() < 0.5 ? 1 : 0);
        }
        // si no se debe enviar el evento, salir
        if (sessionStorage.getItem('envia_eventos_amplitude') == 0) return;
    }
    const event = e.detail || e;
    //segment.track(event.name, event.payload || {});
    // amplitude.track(event.name, event.payload || {});
});
window.addEventListener("segment.identify", (e) => {
    // determinar si existe variable sessionStorage
    if (typeof sessionStorage !== 'undefined') {
        // determinar si existe la variable envia_eventos_amplitude
        if (sessionStorage.getItem('envia_eventos_amplitude') === null) {
            sessionStorage.setItem('envia_eventos_amplitude', Math.random() < 0.5 ? 1 : 0);
        }
        // si no se debe enviar el evento, salir
        if (sessionStorage.getItem('envia_eventos_amplitude') == 0) return;
    }
    const event = e.detail || e;
    //segment.identify(event.userId, event.payload || {});
   // amplitude.identify(event.name, event.payload || {});
});

window.sendTrack = function (name, payload) {
    const event = new CustomEvent('segment.track', { bubbles:true, detail: {name: name, payload:payload} });
    window.dispatchEvent(event);
}
window.sendIdentify = function (name, payload) {
    const event = new CustomEvent('segment.identify', { bubbles:true, detail: {name: name, payload:payload} });
    window.dispatchEvent(event);
}


// Comentar/descomentar segun corresponda (Segment o Rudderstack)

// import { AnalyticsBrowser } from '@segment/analytics-next'
// window.segment = AnalyticsBrowser.load({ writeKey: import.meta.env.VITE_SEGMENT_SOURCE })

// import * as AnalyticsBrowser from "rudder-sdk-js";
// AnalyticsBrowser.load(import.meta.env.VITE_SEGMENT_SOURCE, "https://assetplanmtvj.dataplane.rudderstack.com");
// window.segment = AnalyticsBrowser;
// window.rudderanalytics = AnalyticsBrowser;
